import moment from 'moment'


export const ParseDate = (dateString) => {
  var utcDate = new Date(Date.parse(dateString));
  var date = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
  return date;
}

export const ParseInt = (intString) => {
  if (intString == undefined || intString.length == 0)
      return 0;
  else
  if (isNaN(intString))
      return 0;
  else
      return parseInt(intString);
}

export const FormatServiceDescription = (response) => {
  var result = response.serviceName;
  result += " ";
  result += FormatDuration(response.serviceDuration);
  if (response.resourceName.length > 0)
      result += " - " + response.resourceName;
  return result;
}

export const FormatServiceDuration = (service) => {
    const { duration, durationSelect, durationMin, durationMax, durationInterval } = service
    var tmplDuration;
    
    tmplDuration = `${duration ? duration : 0} min`;

    if (durationSelect) {
        var durationOptions = [];

        for (var i = durationMin;i <= durationMax; i += durationInterval) {
            durationOptions.push(i);
        }

        if (durationOptions) {
            tmplDuration = `
                <select data-serviceid="${service.id}" class="onsched-duration-select">
                    ${durationOptions.map((opt, i) =>
                        `<option key="${i}" value="${opt}">${opt} min</option>`
                    )}
                </select>
            `
        }
        else {
            tmplDuration = ''
        }
    }

    return tmplDuration;
}

export const FormatTime = (time) => {
  if (time == null)
      return "";
  var hour = Math.floor(time / 100);
  var min = time % 100;
  var ampm = hour >= 12 ? "pm" : "am";
  hour = hour > 12 ? hour - 12 : hour;
  var minsString = min.toString();
  minsString = minsString.length < 2 ? minsString + "0" : minsString;
  //        var fmtTime = String.format("{0}:{1} {2}", hour, minsString, ampm);
  var fmtTime = hour + ":" + minsString + " " + ampm;
  return fmtTime;
}

export const FormatDuration = (duration) => {
  var formatted = "none";
  if (duration === null)
      return formatted;

  if (duration <= 0)
      return formatted;
  else
      if (duration > 90 && duration % 60 > 0)
          formatted = Math.floor(duration / 60) + " hours & " + duration % 60 + " min";
      else if (duration > 90)
          formatted = duration / 60 + " hours";
      else
          formatted = duration + " min";

  return formatted;
}

export const FormatPhoneNumber = (ns) => {
  var formatted = "";
  if (ns == undefined)
      return formatted;
  else
  if (ns.length == 10)
      formatted =  "(" + ns.substr(0, 3) + ")" + " " + ns.substr(3, 3) + "-" + ns.substr(6);
  else
  if (ns.length > 10)
      formatted = "+" + ns.substr(0, 2)+ " " + ns.substr(2, 3) + " " + ns.substr(5);
  else
      formatted = ns;
  return formatted;
}

export const ParsePhoneNumber = (strIn) => {
  if (strIn == undefined)
      return "";
  strIn = strIn.trim();

  var parsed = strIn.replace(/[^0-9]/g, '');
              
  return parsed.trim();
}

export const FormatImageData = element => {
    const elSystemFileUploadBtn = document.querySelector(".onsched-wizard.onsched-form input[name=onsched-system-file-upload]");
        
    var base64String;
    var imageData = {};
    
    if (elSystemFileUploadBtn) {
        if (elSystemFileUploadBtn.value) {
            var image = document.getElementById("onsched-image-preview");
            base64String = OnSchedWizardHelpers.Base64Encoded(image); 
            imageData = { imageFileName:elSystemFileUploadBtn.dataset.filename, imageFileData: base64String};
        }
    }
    else {
        imageData = element.params.data.image;
    }

    if (imageData.imageFileName && imageData.imageFileData) {
        imageData.upload = true;
    }

    return imageData;
}

export const FormatFormFields = form => `
  <form class="onsched-form-fields-form" id="${form.name}-form">
  ${
    Object.values(form.inputs).map((formInput, i) => `
      <div class="${form.name}-input-container onsched-input-container">
        <label for="${Object.keys(form.inputs)[i]}">${formInput.label}</label>

        <${formInput.component} 
          type="${formInput.type}" 
          name="${Object.keys(form.inputs)[i]}" 
          value="${formInput.value}" 
          placeholder="${formInput.placeholder}" 
          id="${form.name}-${Object.keys(form.inputs)[i]}-input" 
          ${formInput.disabled ? 'disabled' : ''}
        >

          ${formInput.component === 'select' && formInput.options ? `
            ${formInput.options.map(option => `
              <option value="${option.value}">${option.label}</option>
            `).join('')}
          ` : ''}

        </${formInput.component}>
      </div>
    `).join('')
  }
  </form>
`

export const ToLocaleISOString = (date, tz) => {
  var tzo = tz ? tz : -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
          return (num < 10 ? '0' : '') + num;
      };

  return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
}

export const FormatRescheduleByDateSpan = (oldEvent, newEvent) => {
  let formatted = {
    from: '',
    to: ''
  }

  if (moment(oldEvent).format('YYYY-MM-DD') === moment(newEvent).format('YYYY-MM-DD')) {
    formatted.from = moment(oldEvent).format('h:mma');
    formatted.to = moment(newEvent).format('h:mma');
  }
  else {
    if (moment(oldEvent).format('h:mma') === moment(newEvent).format('h:mma')) {
      formatted.from = moment(oldEvent).format('ddd MMM Do');
      formatted.to = moment(newEvent).format('ddd MMM Do');
    }
    else {
      formatted.from = moment(oldEvent).format('h:mma on ddd MMM Do');
      formatted.to = moment(newEvent).format('h:mma on ddd MMM Do');
    }
  }

  return formatted;
}

export const SplitFullName = name => {
    let firstname = name.split(' ').slice(0, -1).join(' ');
    let lastname = name.split(' ').slice(-1).join(' ');

    // Check if one name or less
    if (name.split(' ').length <= 1) {
        firstname = name;
        lastname = '';
    }

    return { firstname, lastname }
}

export const FormatShortTimeZoneOffset = (calendar) => {
  var timeZone

  if (calendar.currentData.dateEnv.timeZone === 'local') {
    timeZone = moment.tz(moment.tz.guess()).format('z');
  }
  else {
    timeZone = moment.tz(calendar.currentData.dateEnv.timeZone).format('z');
  }
  
  return timeZone;
}